// ------------------------
// public
// ------------------------
// ------------------------
/* home module */
import Home from '../../../../app-module-home-page-landing'
/* login module */
import Login from '../../../../app-module-login-page-landing'
/* account activation module */
import Activation from '../../../../app-module-activation-page-landing'
import ActivationPopup from '../../../../app-module-activation-page-submit-popup'
import ActivationResend from '../../../../app-module-activation-page-resend'
import ActivationResendPopup from '../../../../app-module-activation-page-resend-submit-popup'
/* account verification module */
import Verification from '../../../../app-module-verification-page-landing'
import VerificationPopup from '../../../../app-module-verification-page-submit-popup'
import VerificationResend from '../../../../app-module-verification-page-resend'
import VerificationResendPopup from '../../../../app-module-verification-page-resend-submit-popup'
/* register module */
import Register from '../../../../app-module-register-page-landing'
/* forgot password module */
import ForgotPassword from '../../../../app-module-forgot-password-page-landing'
import ForgotPasswordSubmit from '../../../../app-module-forgot-password-page-submit-popup'
/* reset password module */
import ResetPassword from '../../../../app-module-reset-password-page-landing'
import ResetPasswordPopup from '../../../../app-module-reset-password-page-submit-popup'
import Promotions from '../../../../app-module-promotions-page-landing'
import FAQ from '../../../../app-module-faq-page-landing'
import ClosureFAQ from '../../../../app-module-faq-page-landing-closure-faq'
import SubsquadFaq from '../../../../app-module-subsquadfaq-page-landing'
import ContactUs from '../../../../app-module-contactus-page-landing'
import Terms from '../../../../app-module-terms-page-landing'
import PrivacyNotice from '../../../../app-module-privacynotice-page-landing'
import Cookies from '../../../../app-module-cookies-page-landing'
import Logout from '../../../../app-module-logout-page-landing'
/* impressum */
import ImpressumLanding from '../../../../app-module-impressum-page-landing'
import Subsquad from '../../../../app-module-subsquad-page-landing'
import SubRewards from '../../../../app-module-subrewards-page-landing'
import Unsubscribe from '../../../../app-module-unsubscribe-page-landing'
import UnsubscribeSuccess from '../../../../app-module-unsubscribe-page-success'
import UnsubscribeFail from '../../../../app-module-unsubscribe-page-fail'
import SpinTheWheel from '../../../../app-module-spin-the-wheel-page-landing'

/* campaign */
import Campaign from '../../../../app-module-campaign-landing'
import CampaignSubmit from '../../../../app-module-campaign-submit-landing'

/* home */
const homeModules = [Home]

/* login */
const loginModules = [Login]

/* activation */
const activationModules = [
  Activation,
  ActivationPopup,
  ActivationResend,
  ActivationResendPopup,
]

/* verification */
const verificationModules = [
  Verification,
  VerificationPopup,
  VerificationResend,
  VerificationResendPopup,
]

const registerModules = [Register]

/* forgot password */
const forgotPasswordModules = [ForgotPassword, ForgotPasswordSubmit]

/* reset password */
const resetPasswordModules = [ResetPassword, ResetPasswordPopup]

const promotionsModules = [Promotions]
const faqModules = [FAQ]
const closureFaqModules = [ClosureFAQ]
const squsuadfaqModules = [SubsquadFaq]
const contactUsModules = [ContactUs]
const termsModules = [Terms]
const privacyNoticeModules = [PrivacyNotice]
const cookiesModules = [Cookies]
const logoutModules = [Logout]

/* impressum */
const impressumModules = [ImpressumLanding]

const subsquadModules = [Subsquad]
const subRewardsModules = [SubRewards]

/* usubscribe */
const unsubscribeModules = [Unsubscribe, UnsubscribeSuccess, UnsubscribeFail]

// Spin the wheel
const spinTheWheelModules = [SpinTheWheel]

// const postHome = [PostHome]
// const transferCardModule = [TransferCard]
// const iouModules = [Iou, IouPopup]
/* change password */
// const changePasswordModules = [ChangePassword]

/* news */
// const newsModules = [News, NewsDetail]

/* offers */
// const offersModules = [Offers, OfferDetail]

/* rewards */
// const rewardsModules = [Rewards]

// /* history */
// const historyModules = [History, HistoryDetail]

// const updateModule = [Update]

// const dashboardModules = [DashboardLanding]
// const subsquadModules = [Subsquad]
// const pointsModules = [Points]
// const profileModules = [Profile]
// const preferencesModules = [Preferences]
// const lostcardModules = [LostCard]

/* campaign */
const campaignModules = [Campaign, CampaignSubmit]

const modules = {
  // public //
  home: homeModules,
  login: loginModules,
  activation: activationModules,
  verification: verificationModules,
  register: registerModules,
  forgot_password: forgotPasswordModules,
  reset_password: resetPasswordModules,
  promotions: promotionsModules,
  faq: faqModules,
  subsquadfaq: squsuadfaqModules,
  closure_faq: closureFaqModules,
  contactus: contactUsModules,
  terms: termsModules,
  privacynotice: privacyNoticeModules,
  cookies: cookiesModules,
  logout: logoutModules,
  subsquad: subsquadModules,
  subrewards: subRewardsModules,
  unsubscribe: unsubscribeModules,
  spin_the_wheel: spinTheWheelModules,
  campaign: campaignModules,
}

export default modules
